import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Text, Accordion, showToast } from "@ui-component-library";
import { useCallback } from "react";

const templates = {
  DroneFAQ: {
    headerText: "Drönaranalys",
    faqData: [
      {
        question: "Vilka betalningsmetoder stödjer ni?",
        answer:
          "Du kan betala via Klarna eller faktura, vilket kan väljas när du går igenom processen för betalning på vår plattform.",
      },
      {
        question: "Vad är ett ortofoto?",
        answer:
          "Ett ortofoto är ett högupplöst flygfoto taget med drönare, som ger en exakt och aktuell bild av din skog från ovan. Till skillnad från satellitbilder är ortofoton mycket mer detaljerade och visar skogen precis som den ser ut - där träd, stigar, hyggen och andra detaljer framträder tydligt.",
      },
      {
        question: "Vad är ett ortofoto bra för?",
        answer:
          "Med en drönaranalys får du en tydlig överblick över hela din skogsfastighet i detalj – vilket gör det enklare att planera och följa upp ditt skogsbruk. Du kan uppdatera din skogsbruksplan med hög precision, utan att behöva gå ut i fält. Det gör det också lättare att planera smarta åtgärder, både inför och efter insatser som röjning, gallring, avverkning eller återplantering. Samtidigt sparar du både tid och pengar genom att slippa tidskrävande fältarbete i svår terräng.",
      },
      {
        question: "Hur gör man skadeinventering med hjälp av drönare?",
        answer:
          "Du kan välja att lägga till en skadeinventering till ditt ortofoto. Bilderna kommer då att analyseras för att identifiera exempelvis toppbrott eller angrepp från granbarkborre. Dessa områden kommer att vara utmarkerade, vilket gör det lätt för dig att se, undersöka och agera.",
      },
      {
        question: "Fördelar med skadeinventering med drönare?",
        answer:
          "Med hjälp av skadeanalys från drönare kan du upptäcka skador i tid – som granbarkborreangrepp som annars riskerar att sprida sig snabbt. Du får en tydlig bild av hur väderförhållanden påverkat skogen, till exempel genom toppbrott och snöskador efter stormar eller tungt snöfall. Det gör det lättare att prioritera rätt områden och rikta insatserna dit de gör störst nytta. Med en visuell rapport över skadeläget kan du agera proaktivt och planera åtgärder innan problemen växer sig stora – vilket sparar både resurser och skyddar virkesvärdet.",
      },
      {
        question: "Vad får jag om jag köper Skadeinventering Bas?",
        answer:
          "Denna analys går igenom din skog och markerar alla områden där det finns tecken på angrepp av granbarkborre. Alla områden kommer att vara tydligt markerade i din digitala skogsbruksplan så att du kan undersöka vidare.",
      },
      {
        question: "Vad får jag om jag köper Skadeinventering Plus?",
        answer:
          "I detta paket ingår, utöver skadeinventering för granbarkborre, även en inventering för toppbrott. Toppbrott och snöbrott är när toppen av träden har gått av, ofta på grund av kombinationer av stark vind och tung snö på toppen. Har du toppbrott i din skog bör du undersöka om det kräver en åtgärd, som exempelvis en gallring eller avverkning.",
      },
      {
        question: "Vad är ett snöbrott och vad borde jag veta om det?",
        answer:
          "Snöbrott är en sorts toppbrott som uppstår när tung, blöt snö samlas i träden, ofta i kombination med kyla och blåst. Det är främst unga och täta bestånd som drabbas, särskilt på höjder och i vindutsatta lägen. Tall är extra känslig, medan gran och björk ofta klarar sig bättre. Skadorna kan påverka både tillväxt och virkesvärde, och därför är det viktigt att sköta skogen med rätt röjning och gallring i tid. Efter ett snöfall bör du kontrollera skogen, särskilt där du nyligen gjort åtgärder. Om du hittar skador behöver de tas om hand snabbt för att undvika värdeförluster och angrepp från insekter.",
      },
      {
        question: "Kan jag köpa enbart en skadeanalys och inte ortofoto?",
        answer:
          "Nej, då analysen görs baserat på ortofotot så behöver du alltid köpa ett ortofoto. Olika analyser köps därefter som tillägg.",
      },
      {
        question:
          "Finns det några restriktioner gällande vilka som kan köpa en drönarflygning?",
        answer:
          "Ja, det krävs att drönarpiloten kan ta sig till fastigheten samt att det är tillåtet att flyga med drönare i området. Det är alltså inte möjligt att köpa en drönarflygning om din fastighet ligger på en ö eller i ett militärt område. Du måste även vara ägare till fastigheten eller ha tillstånd från ägaren.",
      },
      {
        question: "Var kan jag vända mig om jag har fler frågor?",
        answer:
          "Du är välkommen att kontakta oss på info@treebula.se så återkommer vi så snabbt vi kan.",
      },
    ],
  },
  GeneralFAQ: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Vad kostar en skogsbruksplan hos Treebula?",
        answer:
          "Du kan skapa en digital skogsbruksplan helt utan kostnad. Den ger dig en bra grundöversikt över din skog. För dig som vill ha full kontroll erbjuder vi Treebula Plus, där planen uppdateras automatiskt och kompletteras med skogsövervakning, virkesprisdata, fastighetsvärdering och rådgivning – allt på ett ställe.",
      },
      {
        question:
          "Vad är Treebulas digitala skogsbruksplan, och hur skiljer den sig från en traditionell plan?",
        answer:
          "Treebulas digitala skogsbruksplan är ett smart digitalt verktyg som ger dig en alltid uppdaterad översikt över din fastighet. – Skillnaden: En traditionell plan är statisk och blir snabbt inaktuell. Vår plan är levande, den uppdateras kontinuerligt med ny data och du kan enkelt anpassa den efter dina egna mål och observationer. – Värde: Den ger dig full kontroll och tillgång till handlingskraftiga insikter om ekonomi, skötsel och miljö.",
      },
      {
        question: "Vilken data ingår i Skogsbruksplanen?",
        answer:
          "Planen ger dig tillgång till all viktig information du behöver för att fatta smarta beslut: – Skogsdata: Uppdaterade kartor, tillstånd, volymer och fördelningar av dina bestånd. – Ekonomi: Insyn i din fastighets värde, förväntade intäkter och kostnader. – Framtid: Riskanalyser (t.ex. för granbarkborre och brand) och insikter i din skogs klimatpåverkan. – Möjligheter: Rådgivning och verktyg för gallring, avverkning och nya intäktsmöjligheter, som att sälja kolkrediter.",
      },
      {
        question: "Hur ofta uppdateras informationen i Skogsövervakningen?",
        answer:
          "Vindfällen: var 2-3 vecka (sommartid). Granbarkborre: analyseras i september och oktober varje år. Väderdata: daglig uppdatering.",
      },
      {
        question: "Hur snabbt får jag veta om något händer i min skog?",
        answer: "Vi skickar en notis så snart akuta förändringar upptäcks.",
      },
      {
        question:
          "Hur säkerställer Treebula att jag får bästa pris för mitt virke och biobränsle?",
        answer:
          "Vi säkerställer bästa pris genom bred konkurrensutsättning. Vi tar in anbud från alla relevanta skogsbolag och köpare i ditt område. Eftersom vi agerar som en oberoende partner, har vi inget egenintresse i vem du väljer. Vårt uppdrag är att du ska förverkliga skogens rätta värden och få marknadens bästa pris.",
      },
      {
        question: `Vad innebär det att Treebula är en "oberoende partner"?`,
        answer:
          "Det innebär att vi står på din sida genom hela virkesaffären. Vi tror på ett rättvist och transparent skogsbruk. Vi agerar som en neutral partner mellan dig och virkesköparna, vilket skapar balans i affären. Du behåller full kontroll över alla beslut och villkor gällande din försäljning.",
      },
      {
        question: "Var kan jag vända mig om jag har fler frågor?",
        answer:
          "Du är välkommen att kontakta oss på 08 - 33 99 44 eller info@treebula.se så återkommer vi så snabbt vi kan.",
      },
    ],
  },
  Fastighetsvardering: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Hur fungerar Treebulas fastighetsvärdering?",
        answer:
          "Vi tar den senaste informationen som finns tillgänglig från gjorda fastighetsaffärer från Svefa och Ludvigf&Co. Vi kombinerar priset med den senaste informationen om din skog.",
      },
      {
        question: "Varför är det bra att förstå en skogsfastighets värdeutveckling?",
        answer:
          "En rättvisande värdering och värdetillväxt hjälper dig att styra skogen mot just ditt mål? Vill du optimera mot maximalt kassaflöde, värdetillväxt eller något annat? Hur mycket kan jag avverka utan att sänka värdet på min fastighet? Lugn, vi hjälper dig.",
      },
      {
        question: "Förklara vad värdetillväxt innebär.",
        answer:
          "Vi multiplicerar din årliga volymtillväxt (m3sk) med den senaste statistiken om fastighetspriser (m3sk). Det ger oss en förståelse av avkastningspotentialen enbart baserad på tillväxten i skogen samt hur mycket virke du kan ta ut utan att sänka värdet på fastigheten.",
      },
    ],
  },
  Virkespriser: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Kostar det något att jämföra virkespriser på Treebula?",
        answer:
          "Som gratismedlem hos Treebula har du tillgång till en begränsad version av vår prisjämförelse. Den kompletta prisjämförelsen som möjliggör ännu smartare beslut om din skog ingår i Treebula Plus.",
      },
      {
        question: "Hur uppdaterade är priserna?",
        answer:
          "Treebula använder de senaste marknadsuppgifterna för att ge dig aktuella priser från köpare i din kommun.",
      },
      {
        question: "Kan jag köpa tjänsten för flera fastigheter?",
        answer:
          "Ja, du kan lägga till flera fastigheter under samma konto. Varje fastighet köps separat.",
      },
      {
        question: "Varför ska man jämföra virkespriser?",
        answer:
          "Genom att jämföra virkespriser får du en tydligare bild av vad ditt virke är värt och kan fatta mer informerade beslut vid försäljning.",
      },
      {
        question: "Vilka faktorer avgör virkespriset?",
        answer:
          "Virkespriset påverkas av trädslag, kvalitet, mängd, köpare som finns i området och lokala marknadsförhållanden.",
      },
      {
        question: "Var kan jag vända mig om jag har fler frågor?",
        answer:
          "Du är välkommen att kontakta oss på 08 - 33 99 44 eller info@treebula.se så återkommer vi så snabbt vi kan.",
      },
    ],
  },
  Kolkrediter: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Vad är kolkrediter och hur fungerar det egentligen?",
        answer:
          "Kolkrediter är ett sätt att få betalt för den koldioxid som din skog binder när du låter den stå kvar. Företag som vill klimatkompensera köper krediterna. Du som skogsägare deltar i ett certifierat projekt (t.ex. Verra) där din skog registreras, och mängden bunden koldioxid beräknas och verifieras innan du får dina krediter.",
      },
      {
        question: "Måste jag avverka mindre för att få kolkrediter?",
        answer:
          "Nej, du behöver inte sluta bruka din skog — men vissa begränsningar finns. Skogen som ingår i projektet måste stå i 40 år, men viss gallring eller plockhuggning är tillåten. Du behåller full äganderätt och kontroll över din fastighet.",
      },
      {
        question: "Hur vet jag om min skog har potential för kolkrediter?",
        answer:
          "Det ser du enkelt i Treebula Plus, där din digitala skogsbruksplan visar vilka avdelningar som har rätt förutsättningar. Vi analyserar både Forestand-filen och din plan för att avgöra vilka områden som binder mest kol och om din skog uppfyller kriterierna för ett kolkreditprojekt.",
      },
      {
        question: "Vad behöver jag för att ansöka om ett kolkreditprojekt?",
        answer:
          "Du behöver två saker: 1. En Forestand-fil från den som gjort din skogsbruksplan. Din skogsbruksplan som PDF. Med dessa kan vi göra en komplett analys och ta fram ett förslag anpassat till just din fastighet.",
      },
      {
        question: "Hur mycket kan jag tjäna på att sälja kolkrediter?",
        answer:
          "Intäkten varierar beroende på hur mycket kol din skog binder och hur stora områden som ingår i projektet. När analysen är klar får du ett skräddarsytt förslag med uppskattad avkastning. Många skogsägare ser kolkrediter som en stabil kompletterande inkomst, utan att behöva avverka ett enda träd.",
      },
    ],
  },
  KontaktaOss: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Kostar det något att kontakta en rådgivare på Treebula?",
        answer:
          "Nej, det är helt kostnadsfritt och utan förbindelser.",
      },
      {
        question: "Hur fungerar det att få rådgivning?",
        answer:
          "Fyll i formuläret via knappen \"Boka rådgivning\", ring eller maila oss. Vi återkommer så fort vi kan. Tillsammans går vi igenom din skogsbruksplan och dina önskemål. Baserat på det gör vi en plan framåt och bestämmer nästa steg. Allt är kostnadsfritt och utan förbindelser.",
      },
      {
        question: "Kostar det något att använda Treebula?",
        answer:
          "Nej, det är helt kostnadsfritt. Oavsett vilken tjänst du använder så är Treebula kostnadsfritt för dig som skogsägare.",
      },
      {
        question: "Hur registrerar jag ett konto på Treebula?",
        answer:
          "Klicka på \"Registrera\" via \"Logga in\". Ange sedan din email-adress eller ditt telefonnummer och följ instruktionerna. Nu har du registrerat ett konto och är redo att använda våra tjänster, helt kostnadsfritt!",
      },
      {
        question: "Hur loggar jag in på mitt konto på Treebula?",
        answer:
          "Vi erbjuder tre enkla sätt att logga in på vår tjänst. BankID, SMS och Email. Välj det alternativ som passar dig bäst.",
      },
      {
        question: "Hur loggar jag in med BankID?",
        answer:
          "Det snabbaste och säkraste sättet att logga in är med BankID. 1. Klicka på \"Logga in med BankID\". 2. Öppna BankID-appen på din mobil, surfplatta eller dator. 3. Scanna QR koden som du ser i din BankID app 4. Följ instruktionerna i appen för att godkänna inloggningen. Du är nu inloggad och redo att använda våra tjänster!",
      },
      {
        question: "Hur loggar jag in med sms?",
        answer:
          "Om du föredrar att logga in med din sms är det också enkelt: 1. Klicka på \"Logga in med SMS\". 2. Skriv in ditt mobilnummer i fältet och klicka på \"Skicka engångskod\". Koden är aktiv i 10 minuter. 3. Du får ett SMS med en kod inom några sekunder. 4. Ange koden på inloggningssidan på Treebula och klicka på \"Bekräfta\". Du är nu inloggad och redo att använda våra tjänster!",
      },
      {
        question: "Hur loggar jag in med Email?",
        answer:
          "Om du föredrar att logga in med din mejladress är det också enkelt: 1. Klicka på \"Logga in med mejladress\". 2. Skriv in din mejladress i fältet och klicka på \"Skicka engångskod\". Koden är aktiv i 10 minuter. 3. Gå till din mejlinkorg och öppna mejlet från Treebula. Koden skickas direkt men kan ibland hamna i skräppost – så kika där om du inte ser det i din inkorg. 4. Ange koden på inloggningssidan på Treebula och klicka på \"Bekräfta\". Du är nu inloggad och redo att använda våra tjänster!",
      },
    ],
  },
  Marknadsinformation: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Vad ingår i den månatliga marknadsanalysen?",
        answer:
          "Vår analys innehåller en sammanställning av aktuella virkespriser för massaved och sågtimmer län för län, förändringar i skogsbolagens grundprislistor, samt en analys av skogsbolagens rapporter och marknadstrender i Sverige och resten av världen. Allt presenteras i ett lättöverskådligt format med Treebulas oberoende expertkommentarer.",
      },
      {
        question: "Hur fungerar Virkesprisindikatorn?",
        answer:
          "Virkesprisindikatorn är vår egen modell som bedömer vartåt virkespriserna sannolikt är på väg. Den baseras på prisdata, marknadsrörelser, rapporter från industrin och Treebulas unika insyn i virkesaffärer över hela landet. Indikatorn visar om marknaden tenderar mot stigande, stabila eller fallande priser.",
      },
      {
        question: "Hur ofta uppdateras prisdatan?",
        answer:
          "Vi uppdaterar priserna och marknadsanalysen varje månad, och följer kontinuerligt förändringar i bolagens listor. På så sätt får du alltid den senaste informationen om virkesmarknaden och skogsbranschen.",
      },
      {
        question: "Var kan jag vända mig om jag har fler frågor?",
        answer:
          "Du är välkommen att kontakta oss på 08 - 33 99 44 eller info@treebula.se så återkommer vi så snabbt vi kan.",
      },
    ],
  },
  SaljVirke: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Hur säkerställer Treebula att jag får bästa pris för mitt virke och biobränsle?",
        answer:
          "Vi säkerställer bästa pris genom bred konkurrensutsättning. Vi tar in anbud från alla relevanta skogsbolag och köpare i ditt område. Eftersom vi agerar som en oberoende partner, har vi inget egenintresse i vem du väljer. Vårt uppdrag är att du ska förverkliga skogens rätta värden och få marknadens bästa pris.",
      },
      {
        question: "Är tjänsten verkligen kostnadsfri?",
        answer:
          "Ja, tjänsten är helt kostnadsfri och du binder dig inte till något. Du har alltid möjlighet att tacka nej till de inkomna anbuden om du inte är nöjd, helt utan förpliktelser. Vi tar en kommission från den vinnande köparen.",
      },
      {
        question: "Vilken typ av virke och biobränsle kan jag sälja genom er?",
        answer:
          "Du kan sälja alla typer av virke och biobränsle. Vår process är utformad för att hantera olika volymer och sortiment, och vi matchar ditt bestånd med köpare som har det största behovet. Vi analyserar din skogliga information för att identifiera rätt bestånd för rätt åtgärd, på dina villkor.",
      },
      {
        question: "Hur går försäljningen till, steg för steg?",
        answer:
          "Processen är utformad för att vara enkel, trygg och transparent: 1. Identifiera åtgärd: Utifrån dina behov och mål identifierar vi rätt åtgärd i rätt tid. Vi står på din sida genom hela affären. 2. Underlag: Vi skapar ett professionellt underlag och ser till att det når alla relevanta köpare i ditt område. 3. Utvärdering: Du får anbud inom 2–3 veckor. Vi hjälper dig att jämföra mellan de olika anbuden, som passar dig och din skog bäst. 4. Kontrakt: Du väljer den bästa köparen och skriver kontrakt direkt med dem. Vi finns där vid din sida för att hjälpa dig.",
      },
      {
        question: `Vad innebär det att Treebula är en "oberoende partner"?`,
        answer:
          "Det innebär att vi står på din sida genom hela affären. Vi tror på ett rättvist och transparent skogsbruk. Vi agerar som en neutral partner mellan dig och köparna, vilket skapar balans i affären. Du behåller full kontroll över alla beslut och villkor gällande din försäljning.",
      },
    ],
  },
  Skogsbruksplan: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Vad kostar en digital skogsbruksplan hos Treebula?",
        answer:
          "Du kan skapa en digital skogsbruksplan helt utan kostnad. Den ger dig en bra grundöversikt över din skog. För dig som vill ha full kontroll erbjuder vi Treebula Plus, där planen uppdateras automatiskt och kompletteras med skogsövervakning, virkesprisdata, fastighetsvärdering och rådgivning – allt på ett ställe.",
      },
      {
        question: "Vad är Treebulas digitala skogsbruksplan, och hur skiljer den sig från en traditionell plan?",
        answer:
          "Treebulas digitala skogsbruksplan är ett smart digitalt verktyg som ger dig en alltid uppdaterad översikt över din fastighet. – Skillnaden: En traditionell plan är statisk och blir snabbt inaktuell. Vår plan är levande, den uppdateras kontinuerligt med ny data och du kan enkelt anpassa den efter dina egna mål och observationer. – Värde: Den ger dig full kontroll och tillgång till handlingskraftiga insikter om ekonomi, skötsel och miljö.",
      },
      {
        question: "Hur snabbt får jag tillgång till min plan?",
        answer:
          "Du kan generera din skogsbruksplan omedelbart och komma igång smärtfritt. – Allt du behöver göra är att ange din fastighetsbeteckning. Därefter får du direkt en tydlig översikt över din skog, redo att användas.",
      },
      {
        question: "Vilken data ingår i planen?",
        answer:
          "Planen ger dig tillgång till all viktig information du behöver för att fatta smarta beslut: – Skogsdata: Uppdaterade kartor, tillstånd, volymer och fördelningar av dina bestånd. – Ekonomi: Insyn i din fastighets värde, förväntade intäkter och kostnader. – Framtid: Riskanalyser (t.ex. för granbarkborre och brand) och insikter i din skogs klimatpåverkan. – Möjligheter: Rådgivning och verktyg för gallring, avverkning och nya intäktsmöjligheter, som att sälja kolkrediter.",
      },
      {
        question: "Hur säkerställer ni att datan är oberoende och pålitlig?",
        answer:
          "Vi agerar som en oberoende spelare. Vårt uppdrag är att skapa rättvisa och transparens i skogsbruket. Vi kopplar samman dig som skogsägare med olika aktörer för att du ska kunna förverkliga skogens alla värden på innovativa och hållbara sätt. Vi har din rygg och skapar balans i branschen.",
      },
    ],
  },
  Skogsovervakning: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Hur ofta uppdateras informationen?",
        answer:
          "Vindfällen: var 2-3 vecka (sommartid). Granbarkborre: analyseras i september och oktober varje år. Väderdata: daglig uppdatering",
      },
      {
        question: "Hur snabbt får jag veta om något händer?",
        answer:
          "Vi skickar en notis så snart akuta förändringar upptäcks.",
      },
      {
        question: "Kan jag köpa tjänsten för flera fastigheter?",
        answer:
          "Ja, du kan lägga till flera fastigheter under samma konto. Varje fastighet köps separat.",
      },
      {
        question: "Om jag får en varning men inte har möjlighet att åka ut i skogen, vad kan jag göra då?",
        answer:
          "Vi erbjuder drönarflygning med högupplösta bilder och möjlighet till djupgående analys av misstänkta angrepp, toppbrott eller fallna träd. Beställ via plattformen i inloggat läge - bild och analys levereras inom ca två veckor.",
      },
      {
        question: "Behöver jag installera något?",
        answer:
          "Nej. Allt sker via vår digitala plattform, du får tillgång direkt efter köp via Kustom Checkout, alternativt när fakturan är betald.",
      },
      {
        question: "Var kan jag vända mig om jag har fler frågor?",
        answer:
          "Du är välkommen att kontakta oss på 08 - 33 99 44 eller info@treebula.se så återkommer vi så snabbt vi kan.",
      },
    ],
  },
  Radgivning: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Kostar det något att boka rådgivning hos er?",
        answer:
          "Rådgivning ingår i att vara Pluskund hos Treebula.",
      },
      {
        question: "Vad kan jag få hjälp med under rådgivningen?",
        answer:
          "Vi utgår alltid från dina behov och mål med just din skog. Vi har detaljkunskap om virkesförsäljning, digital skogsbruksplan, skogsövervakning och möjligheter till kolkrediter. Kan vi inte hjälpa dig ser vi till att du kommer i kontakt med någon i vårt kunniga nätverk.",
      },
      {
        question: "Hur fungerar virkesförsäljning via Treebula?",
        answer:
          "Vi konkurrensutsätter ditt virke genom att bjuda in flera köpare, vilket ofta leder till högre bud. Du får fullt stöd genom hela processen och hjälp att jämföra offerter innan du bestämmer dig. Det är helt kostnadsfritt och du har inga förpliktelser.",
      },
      {
        question: "Behöver jag en digital skogsbruksplan för att använda era tjänster?",
        answer:
          "Nej, men det underlättar. Har du ingen plan hjälper vi dig att skapa en digital och uppdaterad version som ger dig bättre kontroll och tydligare beslutsunderlag.",
      }
    ],
  },
};

const FAQSection = (props) => {
  const selectedTemplate = props.template || "GeneralFAQ";
  const template = templates[selectedTemplate] || templates.GeneralFAQ;
  const headerText = template.headerText || "Vanliga frågor";

  const bgColor = props.backgroundColor || "#ffffff";
  const textColor = props.textColor || "#1A1A1A";
  const mutedTextColor = props.mutedTextColor || "#737373";
  const iconColor = props.iconColor ?? textColor;
  const subHeaderColor = props.subHeaderColor ?? textColor;
  const accordionOpenColor = props.headerColorWhenOpen ?? subHeaderColor;
  
  const sectionRef = useCallback((el) => {
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        showToast('Känner du att du skulle vilja veta mer?', {
          description: 'Boka en genomgång så hjälper vi dig',
          action: {
            label: 'Boka genomgång',
            onClick: () => window.open('/boka-genomgang/', '_self')
          },
          persistent: true,
        });
        observer.disconnect();
      },
      // If the section is 60% visible, show the toast
      { threshold: 0.6 }
    );
    observer.observe(el);
  }, []);

  return (
    <TailwindWrapper>
      <section
        ref={sectionRef}
        className="w-full py-5"
        style={{ backgroundColor: bgColor }}
      >
        <div className="container flex flex-col items-start gap-4 lg:gap-16 lg:flex-row py-3 lg:py-24">
          <div className="w-full flex flex-col gap-8 justify-between">
            <Text
              tw
              variant="overlineLargeRegular"
              style={{ color: mutedTextColor }}
            >
              {props.sectionName}
            </Text>
            <Text
              tw
              variant="text-3xl/leading-normal/medium"
              style={{ color: textColor }}
            >
              {props.title}
            </Text>
            <Text
              tw
              variant="text-base/leading-normal/normal"
              style={{ color: mutedTextColor }}
            >
              {props.text}
            </Text>
          </div>
          <div className="w-full flex flex-col gap-8">
            <Text
              tw
              variant="text-xl/leading-normal/semibold"
              className="mb-2"
              style={{ color: subHeaderColor }}
            >
              {headerText}
            </Text>
            <div className="space-y-4">
              {template.faqData.map((faq) => (
                <Accordion
                  key={faq.question}
                  iconColor={iconColor}
                  iconColorWhenOpen={accordionOpenColor}
                  underline={props.underlineAccordion}
                >
                  <Accordion.Header className="flex items-center gap-3 w-full">
                    {({ isOpen }) => (
                      <Text
                        tw
                        variant="text-sm/leading-normal/medium"
                        style={{
                          color: isOpen ? accordionOpenColor : textColor
                        }}
                      >
                        {faq.question}
                      </Text>
                    )}
                  </Accordion.Header>
                  <Accordion.Content>
                    <Text
                      tw
                      variant="text-sm/leading-normal/normal"
                      style={{ color: mutedTextColor }}
                    >
                      {faq.answer}
                    </Text>
                  </Accordion.Content>
                </Accordion>
              ))}
            </div>
          </div>
        </div>
      </section>
    </TailwindWrapper>
  );
};

FAQSection.defaultProps = {
  sectionName: "FAQ section",
  title: "Frequently asked questions",
  text: "We've compiled the most important information to help you get the most out of your experience. Can't find what you're looking for? Contact us.",
  template: "GeneralFAQ",
  backgroundColor: "#ffffff",
  textColor: "#1A1A1A",
  mutedTextColor: "#737373",
  iconColor: undefined,
  headerColorWhenOpen: undefined,
};

FAQSection.fields = {
  template: {
    type: "select",
    label: "Template",
    options: Object.entries(templates).map(([value, config]) => ({
      label: value,
      value,
    })),
  },
  sectionName: {
    type: "text",
    label: "Section Name",
  },
  title: {
    type: "text",
    label: "Title",
  },
  text: {
    type: "textarea",
    label: "Description Text",
  },
  backgroundColor: {
    type: "text",
    label: "Background colour",
  },
  textColor: {
    type: "text",
    label: "Text colour",
  },
  mutedTextColor: {
    type: "text",
    label: "Secondary text colour",
  },
  iconColor: {
    type: "text",
    label: "Accordion icon colour",
  },
  headerColorWhenOpen: {
    type: "text",
    label: "Accordion header colour when open (e.g. #ECFF8C)",
  },
};

export default FAQSection;
